/**
 * useEdlDraftStore.ts
 * @version 2.0.0 — Re-export de compatibilité
 *
 * La logique a été migrée dans offlinePhotoStore.ts (v4.0.0).
 * Ce fichier existe uniquement pour ne pas casser les imports existants.
 *
 * Tous les appels à edlDraftStore.save/get/clear/getAll
 * sont délégués à offlinePhotoStore.saveDraft/getDraft/clearDraft/getAllDrafts
 *
 * ⚠️ NE PAS supprimer ce fichier — il est importé dans :
 *   - useUploadWorker.ts  (edlDraftStore.clear)
 *   - DoneScreen.tsx      (edlDraftStore.clear)
 *   - PendingQueueScreen  (edlDraftStore.getAll)
 */

import { offlinePhotoStore } from './offlinePhotoStore'

// Re-export du type pour les imports existants
export type { EdlDraft } from './offlinePhotoStore'

/**
 * edlDraftStore — délègue tout à offlinePhotoStore
 * Interface identique à v1.x pour compatibilité totale
 */
export const edlDraftStore = {

  /** @deprecated Utiliser offlinePhotoStore.saveDraft() directement */
  async save(draft: {
    contractId: string
    type:       'depart' | 'retour'
    [key: string]: unknown
  }): Promise<void> {
    await offlinePhotoStore.saveDraft(
      draft.contractId,
      draft.type,
      draft as Record<string, unknown>
    )
  },

  async get(contractId: string, type: 'depart' | 'retour') {
    return offlinePhotoStore.getDraft(contractId, type)
  },

  async getAll() {
    return offlinePhotoStore.getAllDrafts()
  },

  async clear(contractId: string, type: 'depart' | 'retour'): Promise<void> {
    await offlinePhotoStore.clearDraft(contractId, type)
  },

  async exists(contractId: string, type: 'depart' | 'retour'): Promise<boolean> {
    const draft = await offlinePhotoStore.getDraft(contractId, type)
    return draft !== null
  },

} as const